import { lazy } from "react";

import { getDecisioningStudioWizardAllowed } from "@navigationRouting/decisioning_studio/agents/getDecisioningStudioWizardAllowed";
import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DecisioningStudioAgentEditPage = lazy(() =>
  import("@scenes/OfferFit/components/DecisioningStudioAgentEditPage").then((module) => ({
    default: module.DecisioningStudioAgentEditPage,
  }))
);

export const decisioningStudioAgentWizardNRO: NavigationRoutingObject = {
  Component: DecisioningStudioAgentEditPage,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("decisioning-studio-agent-wizard-nro-heading", "Configure BrazeAI Decisioning Studio™ Agent"),
  pageNameForTracking: () => "Configure BrazeAI Decisioning Studio™ Agent",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("decisioning-studio-agent-wizard-nro-description", "Configure a BrazeAI Decisioning Studio™ agent"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    const wizardAllowed = getDecisioningStudioWizardAllowed({ featureOn, hasPermission, isImpersonating });

    // With self-serve action banks on, this URL also serves a Pro agent's action bank editor, so
    // it admits action bank editors too: the page itself decides between the editor, the wizard and
    // a redirect to the details page. A viewer who can edit neither stays out, so links and buttons
    // to this URL keep hiding from them.
    const userCanEditDecisioningStudioActionBanks = hasPermission("appGroup", {
      permission: "editDecisioningStudioActionBanks",
    });
    const actionBankEditorAllowed =
      featureOn("decisioning_studio_self_serve_action_banks") && userCanEditDecisioningStudioActionBanks;

    return wizardAllowed || actionBankEditorAllowed;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
